import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '../elements-tooltip/tooltip-v2';
import changeCase from 'change-case';
import ResponseTime from '../shared-components/responsiveness/ResponseTime';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import classNames from 'classnames';

class Responsiveness extends Component {
  whichColor (level) {
    switch (level) {
    case 1:
      return 'text-green';
    case 2:
      return 'text-yellow';
    case 3:
      return 'text-red';
    default:
      return 'text-green';
    }
  }

  render () {
    const { noTooltip, ownerName, noName, level = 0, responseTime = 0, tooltipParent, tooltipPlacement, placement, labelClassName } = this.props;
    const profileName = noName ? '' : ownerName || this.props.intl.formatMessage({ id: 'inbox.responsiveness.you', defaultMessage: 'You' });
    const responsivenessString = this.props.intl.formatMessage({ id: 'inbox.responsiveness.typically_responds', defaultMessage: "{name} typically {responds}" },
      {
        name: profileName,
        responds: !ownerName
          ? this.props.intl.formatMessage({ id: 'inbox.responsiveness.respond', defaultMessage: 'respond' })
          : this.props.intl.formatMessage({ id: 'inbox.responsiveness.responds', defaultMessage: 'responds' })
      });
    const responsivenessTime = <span className={this.whichColor(level)}><ResponseTime hours={responseTime} /></span>;
    const arrowPlacement = tooltipPlacement || { left: 10 };
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    return (
      <ul className={classNames('responsiveness list-inline no-bottom-margin', { gutter: this.props.useGutter })}>
        <li className="v-center"><i className={`ico ico-md icon-time ${this.whichColor(level)}`} /></li>
        <li className={`v-center text-small ${labelClassName}`} data-testing-id="responsiveness-string">
          {changeCase.upperCaseFirst(responsivenessString)} {responsivenessTime}
        </li>
        {
          !noTooltip ?
            <li className="v-center">
              <Tooltip
                placement={placement || 'bottom'}
                id="responsiveness"
                anchorType="default"
                hideOnClickAnywhere
                parentNode={tooltipParent || this}
                arrowPlacement={arrowPlacement}
              >
                <div>
                  <FormattedMessage
                    id='inbox.responsiveness.hosts_reply'
                    defaultMessage="Guests book more with hosts who reply within 1 hour. {improve}"
                    values={{
                      improve: (
                        <a href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/115000976863`} target="_blank" rel="noopener noreferrer">
                          <FormattedMessage
                            id='inbox.bookings_main.improve_time'
                            defaultMessage="How can I improve my time?"
                          />
                        </a>
                      )
                    }}
                  />
                </div>
              </Tooltip>
            </li> : ''
        }
      </ul>
    );
  }
}

Responsiveness.propTypes = {
  noName: PropTypes.bool,
  ownerName: PropTypes.string,
  noTooltip: PropTypes.bool,
  level: PropTypes.number,
  responseTime: PropTypes.number,
  tooltipParent: PropTypes.object,
  tooltipPlacement: PropTypes.object,
  placement: PropTypes.string,
  labelClassName: PropTypes.string,
  intl: intlShape,
  useGutter: PropTypes.bool
};

Responsiveness.defaultProps = {
  useGutter: true
}

exports.Responsiveness = injectIntl(Responsiveness);
